import type { AlgoliaLanguage } from './algolia.configs'

export enum ProductType {
  FONTS = 'Fonts',
  GRAPHICS = 'Graphics',
  CRAFTS = 'Crafts',
  EMBROIDERY = 'Embroidery',
  BUNDLES = 'Bundles',
  CLASSES = 'Classes',
  COMMUNITY = 'Community',
  THREE_D_SVG = '3d svg',
}

export interface HitItem {
  label: string
  value: string[]
  count: number
  isRefined: boolean
}

type AlgoliaTranslatedString = Record<AlgoliaLanguage, string>

export interface AlgoliaContentHit {
  __position: number
  __queryID: string
  _highlightResult?: {
    title: Record<AlgoliaLanguage, { value: string }>
  }
  authorId: string
  objectID: string
  slug: AlgoliaTranslatedString
  thumbnail: { url: string; width: number; height: number }
  previewMobile: { url: string; width: number; height: number }
  previewDesktop: { url: string; width: number; height: number }
  title: AlgoliaTranslatedString
}

export interface DesignerProfile {
  designerId: number
  designerName: string
  designerUrl: string
  isPremium?: boolean
  premiumLegalEntity?: string
}

export interface SearchProduct {
  aiPrompt?: string
  type: ProductType
  category: string[]
  tags: string[]
  hasPua: boolean
  isExclusive: boolean
  image: string
  url: string
  designer: DesignerProfile
  price: number | string
  usedFonts: string[]
  outsideSubscription: boolean
  hasPod: boolean
  hasPromotions: boolean
  date: number | string
  regularPrice: string | undefined | boolean
  name_en: string
  description_en: string
  name_es: string
  description_es: string
  name_de: string
  description_de: string
  name_fr?: string
  description_fr?: string
  name_it?: string
  description_it?: string
  name_nl?: string
  description_nl?: string
  name_pl?: string
  description_pl?: string
  name_pt?: string
  description_pt?: string
  objectID: string | number
  extraSettings?: {
    level: string
    source: string
    sparkModelType?: string
    sparkModelVersion?: string
    sparkType?: string
  }
  __position: number
  __queryID: string
  isActiveBundle?: boolean
  endDate?: number
}
